import { connect } from 'react-redux'

import UserCongratulationsPopup from './UserCongratulationsPopup'
import {
  endSurveyLink,
  isPostSurveyLink,
  getIdentityName,
  activeProTrackLevel,
} from 'store/entities/identity/selectors'
import { requestSurvey } from 'store/entities/identity/actions'
import { showTypeFormPopup } from 'store/entities/typeform/actions'

const mapStateToProps = state => ({
  postSurveyLink: endSurveyLink(state),
  isPostSurveyLink: isPostSurveyLink(state),
  userName: getIdentityName(state),
  activeProTrackLevel: activeProTrackLevel(state),
})

const mapDispatchToProps = {
  requestSurvey: sendEmail => requestSurvey({ surveyType: 'end', sendEmail }),
  showTypeFormPopup,
}

const mergeProps = ({ postSurveyLink, ...restState }, { showTypeFormPopup, requestSurvey }, own) => ({
  ...restState,
  ...own,
  requestSurvey,
  showTypeFormPopup: () => showTypeFormPopup({ typeFormLink: postSurveyLink, onSubmit: () => requestSurvey(false) }),
})

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(UserCongratulationsPopup)
